import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Trash2, Edit } from "react-feather";
import Table from "../../core/pagination/datatable";
import CommonFooter from "../../core/common/footer/commonFooter";
import TooltipIcons from "../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import {
  getAllStockTransfers,
  updateStockTransfer,
  deleteStockTransfer,
} from "../../api/stockTransferrApi";

import { Download } from "feather-icons-react/build/IconComponents";
import { From, Status, To } from "../../core/common/selectOption/selectOption";
// import DefaultEditor from "react-simple-wysiwyg";
import CommonDeleteModal from "../../core/common/modal/commonDeleteModal";
import { createStockTransfer } from "../../api/stockTransferrApi";
import { getAllWarehouses } from "../../api/warehouseApi";
import { toast } from "react-toastify";
import { api } from "../../api/client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const StockTransfer = () => {
  const [fromWarehouse, setFromWarehouse] = useState(null);
  const [toWarehouse, setToWarehouse] = useState(null);
  const [refNumber, setRefNumber] = useState("");
  // const [productId, setProductId] = useState("");
  const [notes, setNotes] = useState("");
  const [quantityTransferred, setQuantityTransferred] = useState(1);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  // const [productId, setProductId] = useState(null);
  const [currentStock, setCurrentStock] = useState(null);
  const [transferData, setTransferData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [variantId, setVariantId] = useState(null);
  const [editCurrentStock, setEditCurrentStock] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [editForm, setEditForm] = useState({
    fromWarehouse: null,
    toWarehouse: null,
    refNumber: "",
    productId: null,
    quantityTransferred: 1,
    notes: "",
  });

  const handleEditChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  const fetchTransfers = async () => {
    try {
      const data = await getAllStockTransfers();
      setTransferData(data);
    } catch (err) {
      // toast.error("Failed to load stock transfers");
      toast.error(`❌ ${window.translate("Failed to load stock transfers")}`);
    }
  };

  useEffect(() => {
    fetchTransfers();
  }, []);

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const data = await getAllWarehouses();

        const options = data.map((wh) => ({
          value: wh.id,
          label: wh.warehouse,
        }));

        setWarehouseOptions(options);
      } catch (error) {
        // toast.error("Failed to load warehouses");
        toast.error(`❌ ${window.translate("Failed to load warehouses")}`);
      }
    };

    fetchWarehouses();
  }, []);

  // useEffect(() => {
  //   const fetchCurrentStock = async () => {
  //     if (fromWarehouse && selectedProduct?.value) {
  //       try {
  //         const res = await fetch(
  //           `${API_BASE_URL}api/stock-transfer/quantity/${fromWarehouse.value}/${selectedProduct.value}`
  //         );
  //         const data = await res.json();
  //         setCurrentStock(data.quantity ?? 0);
  //       } catch (err) {
  //         console.error(err);
  //         toast.error("❌ Could not fetch current stock");
  //         setCurrentStock(null);
  //       }
  //     }
  //   };

  //   fetchCurrentStock();
  // }, [fromWarehouse, selectedProduct]);

  useEffect(() => {
    const fetchCurrentStock = async () => {
      if (fromWarehouse && selectedProduct?.value) {
        try {
          const res = await api.get(
            `${API_BASE_URL}api/stock-transfer/quantity/${fromWarehouse.value}/${selectedProduct.value}`
          );
          const data = res.data;
          setCurrentStock(data.quantity ?? 0);
          setVariantId(data.variantId || null);
        } catch (err) {
          // toast.error("❌ Could not fetch current stock");
          toast.error(`❌ ${window.translate("Could not fetch current stock")}`);
          setCurrentStock(null);
          setVariantId(null);
        }
      }
    };

    fetchCurrentStock();
  }, [fromWarehouse, selectedProduct]);

  const handleTransferSubmit = async (e) => {
    e.preventDefault();

    if (!fromWarehouse || !toWarehouse || !refNumber || !selectedProduct) {
      // toast.error("All required fields must be filled.");
      toast.error(`❌ ${window.translate("All required fields must be filled")}`);
      return;
    }

    try {
      const payload = {
        fromWarehouse: fromWarehouse.value,
        toWarehouse: toWarehouse.value,
        refNumber,
        product: selectedProduct?.value,
        variant: variantId || undefined, // ✅ added line
        quantityTransferred,
        notes,
      };

      await createStockTransfer(payload);
      // toast.success("✅ Stock transferred successfully");
      toast.success(` ${window.translate("Stock transferred successfully")}`);

      document.getElementById("close-add-stock-btn")?.click();
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (err) {
      // toast.error(err.message || "❌ Stock transfer failed");
      toast.error(`❌ ${window.translate("Stock transfer failed")}`);
    }
  };

  const filteredToOptions = warehouseOptions.filter(
    (w) => w.value !== fromWarehouse?.value
  );
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        id: editId, // ✅ INCLUDE THIS!
        fromWarehouse: editForm.fromWarehouse?.value,
        toWarehouse: editForm.toWarehouse?.value,
        refNumber: editForm.refNumber,
        product: editForm.productId?.value,
        quantityTransferred: parseInt(editForm.quantityTransferred),
        notes: editForm.notes,
      };

      await updateStockTransfer(editId, payload);
      // toast.success("Transfer updated!");
      toast.success(` ${window.translate("Transfer updated!")}`);
      fetchTransfers();
      // Close modal if needed here (optional)
      document.getElementById("close-add-stock-btn")?.click();

      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (err) {
      // toast.error(err?.response?.data?.message || "Failed to update transfer.");
      toast.error(`❌ ${window.translate("Failed to update transfer.")}`);
    }
  };

  const handleEditClick = async (record) => {
    setEditId(record.id);

    const fromOption = warehouseOptions.find(
      (opt) => opt.label === record.fromWarehouse
    );
    const toOption = warehouseOptions.find(
      (opt) => opt.label === record.toWarehouse
    );

    try {
      const res = await api.get(
        `${API_BASE_URL}api/products/by-warehouse/${fromOption.value}`
      );
      const data = res.data;

      const productOpts = data.map((prod) => ({
        // value: prod.productId,
        value: prod.productId || prod.value || prod._id,
        // value: prod.value || prod._id,
        label: prod.label || "Unnamed",
        sku: prod.sku || "N/A",
        image: prod.image,
      }));

      setProductOptions(productOpts);

      // ✅ record.product is just the ID (string), not an object
      const selectedProduct = productOpts.find(
        (p) => p.value === record.product
      );

      if (!selectedProduct) {
        // toast.error("⚠️ Product not found in fetched product list.");
        toast.error(`❌ ${window.translate("Product not found in fetched product list")}`);
      }

      setEditForm({
        fromWarehouse: fromOption,
        toWarehouse: toOption,
        refNumber: record.refNumber,
        productId: selectedProduct || null,
        quantityTransferred: record.quantityTransferred,
        notes: record.notes,
      });

      // ✅ Fetch current stock using product ID from record
      const stockRes = await api.get(
        `${API_BASE_URL}api/stock-transfer/quantity/${fromOption.value}/${record.product}`
      );
      const stockData = stockRes.data;
      setEditCurrentStock(stockData.quantity ?? 0);
    } catch (error) {
      console.error("❌ EditClick Error:", error);
      // toast.error("Failed to fetch product or stock data");
      toast.error(`❌ ${window.translate("Failed to fetch product or stock data")}`);
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      await deleteStockTransfer(deleteId);
      // toast.success("✅ Stock transfer deleted successfully");
      toast.success(` ${window.translate("Stock transfer deleted successfully")}`);
      fetchTransfers(); // refresh the table/list
      setDeleteId(null); // reset selected ID
      // Close modal if needed here (optional)
      document.getElementById("close-add-stock-btn")?.click();

      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (err) {
      // toast.error("❌ Failed to delete stock transfer");
      toast.error(`❌ ${window.translate("Failed to delete stock transfer")}`);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteId(null); // reset selected ID
  };

  const columns = [
    {
      title: window.translate("From Warehouse"),
      dataIndex: "fromWarehouse",
      sorter: (a, b) => a.fromWarehouse.length - b.fromWarehouse.length,
    },
    {
      title: window.translate("To Warehouse"),
      dataIndex: "toWarehouse",
      sorter: (a, b) => a.toWarehouse.length - b.toWarehouse.length,
    },
    // {
    //   title: "No Of Products",
    //   dataIndex: "noOfProducts",
    //   sorter: (a, b) => a.noOfProducts.length - b.noOfProducts.length,
    // },

    {
      title: window.translate("Quantity Transferred"),
      dataIndex: "quantityTransferred",
      sorter: (a, b) =>
        a.quantityTransferred.length - b.quantityTransferred.length,
    },

    {
      title: window.translate("Ref Number"),
      dataIndex: "refNumber",
      sorter: (a, b) => a.refNumber.length - b.refNumber.length,
    },

    {
      title: window.translate("Date"),
      dataIndex: "date",
      sorter: (a, b) => a.date.length - b.date.length,
    },

    {
      title: window.translate("Action"),
      dataIndex: "action",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-units"
              onClick={() => handleEditClick(record)}
            >
              <Edit className="feather-edit" />
            </Link>

            <Link
              className="confirm-text p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={() => setDeleteId(record.id)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  // const [quantity, setQuantity] = useState(4);

  // const handleDecrement = () => {
  //   if (quantity > 1) {
  //     setQuantity(quantity - 1);
  //   }
  // };

  // const handleIncrement = () => {
  //   setQuantity(quantity + 1);
  // };
  // const [values, setValue] = useState();
  // function onChange(e) {
  //   setValue(e.target.value);
  // }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Stock Transfer")}</h4>
                <h6>{window.translate("Manage your stock transfer")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <i className="ti ti-circle-plus me-2 ms-2"></i>
                {window.translate("Add New")}
              </Link>
            </div>
            <div className="page-btn import">
              <Link
                to="#"
                className="btn btn-secondary color"
                data-bs-toggle="modal"
                data-bs-target="#view-notes"
              >
                <Download className="me-2" />
                {window.translate("Import Transfer")}
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card manage-stock">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {window.translate("From Warehouse")}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Lavish Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Quaint Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Traditional Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Cool Warehouse
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {window.translate("To Warehouse")}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        North Zone Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Nova Storage Hub
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Cool Warehouse
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Retail Supply Hub
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {window.translate("sortLast7Days")}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("recentlyAdded")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("ascending")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("descending")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("lastMonth")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("last7Days")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="custom-datatable-filter table-responsive">
                {transferData.length > 0 ? (
                  <Table columns={columns} dataSource={transferData} />
                ) : (
                  <p className="text-center mb-2">
                    {window.translate("No stock transfer records found")}.
                  </p>
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>

      {/* Add Stock */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="page-title">
                <h4>{window.translate("Add Transfer")}</h4>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form onSubmit={handleTransferSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">
                        {window.translate("Warehouse From")}{" "}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={warehouseOptions}
                        placeholder="Choose"
                        // onChange={async (selected) => {
                        //   setFromWarehouse(selected); // will trigger useEffect
                        //   try {
                        //     const res = await fetch(
                        //       `${API_BASE_URL}api/products/by-warehouse/${selected.value}`
                        //     );
                        //     const data = await res.json();

                        //     const productOpts = data.map((prod) => ({
                        //       // value: prod.value || prod._id,
                        //       value: prod.productId,
                        //       label: prod.label || "Unnamed",
                        //       sku: prod.sku || "N/A",
                        //       image: prod.image,
                        //     }));

                        //     setProductOptions(productOpts);
                        //   } catch (err) {
                        //     toast.error(
                        //       "Could not load products from warehouse"
                        //     );
                        //   }
                        // }}
                        onChange={async (selected) => {
                          setFromWarehouse(selected); // Triggers stock fetch via useEffect
                          try {
                            const res = await api.get(
                              `${API_BASE_URL}api/products/by-warehouse/${selected.value}`
                            );
                            const data = res.data;

                            const productOpts = data.map((prod) => ({
                              // be robust to different shapes coming from the API
                              value: prod.productId || prod.value || prod._id,
                              label: prod.label || prod.name || "Unnamed",
                              sku: prod.sku || "N/A",
                              image: prod.image,
                            }));

                            setProductOptions(productOpts);
                          } catch (err) {
                            // toast.error(
                            //   "Could not load products from warehouse"
                            // );
                            toast.error(`❌ ${window.translate("Could not load products from warehouse")}`);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">
                        {window.translate("Warehouse To")}<span className="text-danger ms-1">*</span>
                      </label>

                      <Select
                        classNamePrefix="react-select"
                        options={filteredToOptions}
                        placeholder="Choose"
                        onChange={(selected) => setToWarehouse(selected)}
                      />

                      {/* <Select
                        classNamePrefix="react-select"
                        options={warehouseOptions}
                        placeholder="Choose"
                        onChange={(selected) => setToWarehouse(selected)}
                      /> */}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        {window.translate("Reference Number")}{" "}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      {/* <input type="text" className="form-control" /> */}
                      <input
                        type="text"
                        className="form-control"
                        value={refNumber}
                        onChange={(e) => setRefNumber(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3 search-form mb-3">
                      <label className="form-label">
                        {window.translate("Product")} <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={productOptions}
                        placeholder="Select Product"
                        value={selectedProduct}
                        onChange={(selected) => {
                          setSelectedProduct(selected);
                        }}
                      />
                      {/* <Select
                        classNamePrefix="react-select"
                        options={productOptions}
                        placeholder="Select Product"
                        value={selectedProduct}
                        onChange={(selected) => {
                          setSelectedProduct(selected); // Save full object
                        }}
                      /> */}

                      {currentStock !== null && (
                        <p className="text-muted mt-1">
                          {window.translate("Current stock in this warehouse")}:{" "}
                          <strong>{currentStock}</strong>
                        </p>
                      )}

                      {/* <i data-feather="search" className="feather-search" /> */}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        {window.translate("Quantity Transferred")}{" "}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={quantityTransferred}
                        onChange={(e) =>
                          setQuantityTransferred(Number(e.target.value))
                        }
                        min={1}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="search-form mb-0">
                      <label className="form-label">
                        {window.translate("Notes")} <span className="text-danger ms-1">*</span>
                      </label>
                      {/* <textarea className="form-control" defaultValue={""} /> */}
                      <textarea
                        className="form-control"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  data-bs-dismiss="modal"
                >
                   {window.translate("Cancel")}
                </button>
                <button type="submit" className="btn btn-primary">
                  {window.translate("Create")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Stock */}

      {/* Edit Stock */}
      <div className="modal fade" id="edit-units">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4>{window.translate("Edit Transfer")}</h4>
              <button type="button" className="close" data-bs-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <form onSubmit={handleEditSubmit}>
              <div className="modal-body">
                <label>{window.translate("From Warehouse")}</label>
                <Select
                  options={warehouseOptions}
                  value={editForm.fromWarehouse}
                  onChange={async (value) => {
                    handleEditChange("fromWarehouse", value);

                    try {
                      const res = await api.get(
                        `${API_BASE_URL}api/products/by-warehouse/${value.value}`
                      );
                      const products = res.data;

                      const productOpts = products.map((prod) => ({
                        // value: prod.value || prod._id,
                        // value: prod.productId,
                        value: prod.productId || prod.value || prod._id,
                        label: prod.label || "Unnamed",
                        sku: prod.sku || "N/A",
                        image: prod.image,
                      }));

                      setProductOptions(productOpts);
                      handleEditChange("productId", null); // Reset selected product
                      setEditCurrentStock(null);
                    } catch {
                      // toast.error("Failed to fetch products");
                      toast.error(`❌ ${window.translate("Failed to fetch products")}`);
                    }
                  }}
                />

                <label>{window.translate("To Warehouse")}</label>
                <Select
                  options={warehouseOptions}
                  value={editForm.toWarehouse}
                  onChange={(value) => handleEditChange("toWarehouse", value)}
                />
                <label>{window.translate("To Warehouse")}</label>
                <input
                  type="text"
                  className="form-control"
                  value={editForm.refNumber}
                  onChange={(e) =>
                    handleEditChange("refNumber", e.target.value)
                  }
                />

                <label>{window.translate("Product")}</label>
                <Select
                  classNamePrefix="react-select"
                  options={productOptions}
                  placeholder="Select Product"
                  value={editForm.productId}
                  onChange={async (selected) => {
                    handleEditChange("productId", selected);

                    if (selected?.value && editForm.fromWarehouse?.value) {
                      try {
                        const res = await api.get(`${API_BASE_URL}api/stock-transfer/quantity/${editForm.fromWarehouse.value}/${selected.value}`);
                        const data = res.data;
                        setEditCurrentStock(data.quantity ?? 0);
                      } catch (err) {
                        // toast.error("Failed to fetch stock");
                        toast.error(`❌ ${window.translate("Failed to fetch stock")}`);
                        setEditCurrentStock(null);
                      }
                    }
                  }}
                />
                {editCurrentStock !== null && (
                  <p className="text-muted mt-1">
                    {window.translate("Current stock in this warehouse")}:{" "}
                    <strong>{editCurrentStock}</strong>
                  </p>
                )}

                <label>{window.translate("Quantity")}</label>
                <input
                  type="number"
                  className="form-control"
                  value={editForm.quantityTransferred}
                  onChange={(e) =>
                    handleEditChange("quantityTransferred", e.target.value)
                  }
                />
                <label>{window.translate("Notes")}</label>
                <textarea
                  className="form-control"
                  value={editForm.notes}
                  onChange={(e) => handleEditChange("notes", e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">
                  {window.translate("Save Changes")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Stock */}

      {/* Import Transfer */}
      <div className="modal fade" id="view-notes">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div className="page-title">
                <h4>Import Transfer</h4>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        From<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={From}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        To<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={To}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Satus<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={Status}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-6 col-12">
                    <div className="row">
                      <div>
                        <div className="modal-footer-btn download-file">
                          <Link
                            to="javascript:void(0)"
                            className="btn btn-submit"
                          >
                            Download Sample File
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3 image-upload-down">
                      <label className="form-label"> Upload CSV File</label>
                      <div className="image-upload download">
                        <input type="file" />
                        <div className="image-uploads">
                          <ImageWithBasePath
                            src="assets/img/download-img.png"
                            alt="img"
                          />
                          <h4>
                            Drag and drop a <span>file to upload</span>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Shipping<span className="text-danger ms-1">*</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-3 summer-description-box transfer">
                    <label className="form-label">
                      {window.translate("description")}
                    </label>
                    <div id="summernote3"></div>
                    <p>Maximum 60 Characters</p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <Link
                  to="#"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Submit
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Import Transfer */}
      <CommonDeleteModal
        onConfirm={handleDeleteConfirm}
        
        onCancel={handleDeleteCancel}
      />
    </>
  );
};

export default StockTransfer;
